import React from "react"
import { SelectField, MenuItem } from "material-ui"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import { IPayType, IPayrollPayGroupData } from "../../models"

interface IProps {
    // not set default paytype if selected paytype is not exist
    setInit?: boolean
    readonly?: boolean
    selectedPayTypeId: string
    errorSelectedPayTypeId?: string
    handleSelect(payTypeId: string): void

    // if allowAllPayTypes is true, all paytypes of account are avaialble to select
    // in this case, not need payrollPayGroupData
    allowAllPayTypes?: boolean
    payrollPayGroupData?: IPayrollPayGroupData

    // need it in the case selected paytype removed
    showAllRemovedPayType?: boolean
}

const PayTypeSelector: React.SFC<IProps> = (props: IProps) => {
    let payTypes: IPayType[]
    let payGroupId: string
    let payGroupLinkedPayTypes: IPayType[]
    if (props.showAllRemovedPayType) {
        payTypes = AccountStore.getCurrentAccount().PayTypes
    }
    else if (props.allowAllPayTypes) {
        payTypes = AccountStore.getCurrentAccount().PayTypes.filter(i => !i.Deleted)
    }
    else {
        payGroupId = payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData(props.payrollPayGroupData)
        payGroupLinkedPayTypes = payGroupAndTypeHelper.getLinkedPayTypes(payGroupId)
        payTypes = payGroupLinkedPayTypes
    }

    // if the selected paytype not exist, need to set as default
    props.setInit && !props.selectedPayTypeId &&
        props.handleSelect(payGroupId ?
            payGroupAndTypeHelper.getDefaultPayType(payGroupId).Id :
            payTypes[0].Id
        )

    return (
        <SelectField
            data-intercom-target={"Select-Paytype"}
            floatingLabelText={strings.Pay_Type}
            value={props.selectedPayTypeId}
            onChange={(even, tey, payTypeId) => props.handleSelect(payTypeId)}
            disabled={props.readonly}
            errorText={props.errorSelectedPayTypeId}
            errorStyle={{ position: "absolute", top: 70 }}
        >
            {payTypes.map((payType, key) =>
                <MenuItem
                    key={key}
                    value={payType.Id}
                    primaryText={payType.Name}
                    disabled={(!props.allowAllPayTypes && props.showAllRemovedPayType) && (payGroupLinkedPayTypes && !payGroupLinkedPayTypes.find(item => item.Id === payType.Id))}
                />
            )}
        </SelectField>
    )
}

export default PayTypeSelector